import {useState} from 'react';
import {SearchParamsKey, useUrlParams} from "@/app/utils/search_params";
import {AuthRequests, ErrorModel, LoginWithPinModel, LoginWithPinResponseModel} from "@/app/api/auth";
import {CookiesKey, useCookies} from "@/app/utils/cookies";
import {useNavigate} from "react-router-dom";

const useEnterPin = () => {
  const [code, setCode] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const {getUrlParam} = useUrlParams();
  const {setCookie} = useCookies();
  const navigate = useNavigate();

  const updateCode = async (code: string) => {
    setDisabled(!(code.length === 4));
    setCode(code);
  };

  const continued = async () => {
    if (error != null) setError(null);

    if (code.length === 4) {
      setLoading(true);
      const phone: string = (getUrlParam(SearchParamsKey.phone) ?? '').replace("+", "");

      const model: LoginWithPinModel = {pin: code, phoneNumber: phone};
      let response: LoginWithPinResponseModel

      try {
        response = await AuthRequests.loginWithPin(model);

      } catch (error: ErrorModel | any) {
        const s = error as ErrorModel;
        setError(s.message);
        setLoading(false);
        return;
      }

      if (response.token != null) {
        setCookie(CookiesKey.token, response.token);
        setLoading(false);
        navigate('/', {replace: true});
      }
    }

    setError(null);
    return;
  };

  return {
    code,
    setCode: updateCode,
    continued,
    loading,
    error,
    disabled,
  };
};

export default useEnterPin;